export default __webpack_public_path__ + "static/media/nft.d46280a2.png";